import React, {Component} from 'react';
import {Header, Modal} from "semantic-ui-react";
import {CLAIMS_ROUTE, CONDITIONS_ROUTE, LEARN_ABOUT_COVERAGE_ROUTE} from "../utils/common";
import {ClickableText, CustomModalHeader} from "./custom-common";

class TipsModal extends Component {
    constructor(props) {
        super(props);
        this.learnAboutBrellaRef = React.createRef();
        this.conditionsRef = React.createRef();
        this.claimsRef = React.createRef();
    }

    componentDidMount() {
        this.scrollToRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.scrollToRef();
    }

    getScrollToRefBasedOnRoute = () => {
        const route = window.location.pathname;
        if (route.endsWith(LEARN_ABOUT_COVERAGE_ROUTE)){
            return this.learnAboutBrellaRef;
        }
        if (route.endsWith(CONDITIONS_ROUTE)){
            return this.conditionsRef;
        }
        if (route.endsWith(CLAIMS_ROUTE)){
            return this.claimsRef;
        }

        return null;
    }

    scrollToRef = () => {
        const scrollToRef = this.getScrollToRefBasedOnRoute();
        if(!!scrollToRef && !!scrollToRef.current){
            scrollToRef.current.scrollIntoView({behavior: 'smooth'});
        }
    }

    render() {
        const {strings, displayTipsModal, onModalClose, onDisplayCoveredModalClick, benefitLimits} = this.props;

        return (
            <Modal size={'tiny'} onClose={onModalClose} open={displayTipsModal} >
                <CustomModalHeader title={strings.title} onClose={onModalClose}/>
                <Modal.Content style={{maxHeight:'513px', overflowY: 'auto'}} className={"small"}>
                    <div ref={this.learnAboutBrellaRef}/>
                        <Header as={"h4"}>{strings.brellaVsHealthIns}</Header>
                    <p><b>{strings.doesBrellaReplace}</b></p>
                    <p>{strings.brellaReplaceDescr}</p>

                    <div ref={this.conditionsRef}/>
                        <Header as={"h4"}>{strings.allAboutCoverage}</Header>

                    <p><b>{strings.whatsCovered}</b></p>

                    <p>{strings.wcDecr}<span>{' '}
                        <ClickableText onClick={onDisplayCoveredModalClick}>
                            {strings.wcDescr2}</ClickableText>{' '}</span>
                        {strings.wcDescr3}</p>

                    <p><b>{strings.amICovered}</b></p>
                    <p>{strings.amICoveredDescr}</p>

                    <p><b>{strings.doesYourPlan}</b></p>
                    <p>{strings.doesYourPlanDescr}</p>

                    <p><b>{strings.willBrellaCover}</b></p>
                    <p>{strings.willBrellaCoverDescr}</p>

                    <p><b>{strings.doIHaveToGo}</b></p>
                    <p>{strings.doIHaveToGoDescr}</p>

                    <div ref={this.claimsRef}/>
                        <Header as={"h4"}>{strings.allAboutClaims}</Header>
                    <p><b>{strings.whatCountsAs}</b></p>
                    <p>{strings.whatCountsAsDescr}</p>

                    <p><b>{strings.howOftenCanI}</b></p>
                    { benefitLimits?.howOftenSubmitClaimText &&
                        <p>{ benefitLimits.howOftenSubmitClaimText?.split('\n').map((paragraph, index) =>
                            <React.Fragment key={index}>{paragraph}<br/></React.Fragment>) }</p>
                    }
                    { benefitLimits?.adminChangeText && <p>{ benefitLimits.adminChangeText }</p> }
                    { benefitLimits?.forEachCategoryText && <p>{ benefitLimits?.forEachCategoryText }</p> }
                    <p><b>{strings.howLongDoI}</b></p>
                    <p>{strings.howLongDoIDescr}</p>
                    <br/>
                </Modal.Content>
            </Modal>
        );
    }
}

export default TipsModal;
